export default (() => {

    function isBoolean (value) {
        if (value === undefined) {
            return wealthify.error.throwError('type.boolean.isBoolean', 'value must be defined');
        }

        if (typeof value === 'string') {
            return value.toLowerCase() === 'true' || value.toLowerCase() === 'false';
        }

        return typeof value === 'boolean';
    }

    function toBoolean (value) {
        if (value === undefined) {
            return wealthify.error.throwError('type.boolean.toBoolean', 'value must be defined');
        }

        if (!wealthify.type.boolean.isBoolean(value)) {
            return null;
        }
        
        return value.toString().toLowerCase() === 'true';
    }
    
    return {
        isBoolean,
        toBoolean
    };

})();